<template>
  <div>
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Pedido #{{pedido.idPedidoVindi}}</h3>
            </div>
            <div class="col-auto">
              <b-button @click="voltar">Voltar</b-button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-4">
          <b-alert :show="pedido.vads_trans_status === 'Cancelado'" variant="danger">
            <h4 class="alert-heading">Atenção</h4>
            <p style="font-weight: bold">
              Esse pedido encontra-se CANCELADO!
            </p>
          </b-alert>
        </div>
        <div class="col">
          <div class="element-wrapper pb-0">
            <b-card header="Pedido">
              <div class="container">
                <div class="row">
                  <div class="col">
                    <label for>Pedido</label>
                    <h5>{{pedido.idPedidoVindi}}</h5>
                  </div>
                  <div class="col" v-if="isUtilizaPlataformaPagamento">
                    <label for>Status</label>
                    <br />
                    <b-badge
                      :variant="getTextStatusPagamento(pedido.vads_trans_status) === 'Pago' ? 'success' : 'warning'"
                    >{{getTextStatusPagamento(pedido.vads_trans_status)}}</b-badge>
                  </div>
                  <div class="col" v-if="isUtilizaPlataformaPagamento">
                    <label for>Forma de pagamento</label><br>
                    <b-badge variant="warning">{{getTextFormaPagamento(pedido.formadePagamento)}}</b-badge>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-5">
                    <label for>Plano</label>
                    <h5>{{pedido.plano.name}}</h5>
                  </div>
                  <div class="col">
                    <label for>Preço</label>
                    <h5>{{pedido.plano.price | money}}/mês</h5>
                  </div>
                  <div class="col" v-if="pedido.plano.valorTaxaAdesao">
                    <label for>Taxa Adesão</label>
                    <h5>{{pedido.plano.valorTaxaAdesao | money}}</h5>
                  </div>
                  <div class="col" v-if="(pedido.tipoEnvioFatura.length>0) && isAdministrador">
                    <label>Enviar Fatura(via):</label>
                    <h6 v-for ="(tipoEnvio,index) in pedido.tipoEnvioFatura" :key="index">
                      {{tipoEnvio}}
                    </h6>
                  </div>
                </div>
                <hr v-if="cartao && cartao.numeroCartao" />
                <div class="row" v-if="cartao && cartao.numeroCartao">
                  <div class="col-6">
                    <label for>Número Cartão</label>
                    <h5>{{cartao.numeroCartao.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/ig, '$1 $2 $3 $4')}}</h5>
                  </div>
                  <div class="col">
                    <label for>Status Cartão</label>
                    <br />
                    <b-badge
                      :variant="cartao.status === 'Habilitado' ? 'success' : 'warning'"
                    >{{cartao.status}}</b-badge>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col">
                    <label>Dados Cliente</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label for>Nome</label>
                    <h5>{{pedido.client.name}}</h5>
                  </div>
                  <div class="col">
                    <label for>CPF</label>
                    <h5>{{pedido.client.cpf}}</h5>
                  </div>
                  <div class="col">
                    <label for>Data Nascimento</label>
                    <h5>{{pedido.client.dataNascimento}}</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for>Telefone Celular</label>
                    <h5>{{pedido.client.telefoneCelular}}</h5>
                  </div>
                  <div class="col">
                    <label>Telefone Fixo</label><br>
                    <h5>{{pedido.client.telefoneFixo}}</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for>Email</label>
                    <h5>{{pedido.client.email}}</h5>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col">
                    <label>Endereço</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label>Logradouro</label>
                    <h5>{{pedido.client.enderecoResidencial}}</h5>
                  </div>
                  <div class="col">
                    <label>Número</label><br>
                    <h5>{{pedido.client.enderecoNumero}}</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label>CEP</label>
                    <h5>{{pedido.client.cep}}</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label>Bairro</label>
                    <h5>{{pedido.client.bairro}}</h5>
                  </div>
                  <div class="col">
                    <label>Cidade</label>
                    <h5>{{pedido.client.cidade}}</h5>
                  </div>
                  <div class="col">
                    <label>UF</label>
                    <h5>{{pedido.client.uf}}</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label>Complemento</label><br>
                    <h5>{{pedido.client.endereComplemento}}</h5>
                  </div>
                </div>
                <hr />
                <div
                  class="row"
                  v-if="pedido.client.dependentes && pedido.client.dependentes.length > 0"
                >
                  <div class="col">
                    <label>Dependentes</label>
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Nome</th>
                          <th>CPF</th>
                          <th>DataNascimento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(dependente, index) in pedido.client.dependentes" :key="index">
                          <td>
                            <h6 class="user-title">{{dependente.name || dependente.NomeDependente}}</h6>
                          </td>
                          <td>{{dependente.cpf || dependente.CPF_Dependente}}</td>
                          <td>{{dependente.dataNascimento}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
        <div class="col-3" >
          <div class="element-wrapper pb-0" v-if="pedido.vads_trans_status === 'Cancelado'">
            <b-card>
              <b-list-group>
                <b-list-group-item button @click="openModalDocumento">
                  <i class="fas fa-file-contract"></i>
                  Documentos <h7 v-if="pedido.documentoExiste==false">(Pendente)</h7>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </div>
          <div class="element-wrapper pb-0" v-else-if="pedido.vads_trans_status !== 'Cancelado'">
            <b-card>
              <b-list-group>
                <b-list-group-item v-if="isAdministrador && isUtilizaPlataformaPagamento
                    && isUtilizaVindi" button @click="atualizarDadosFinanceiros">
                  <i class="fa fa-credit-card"></i>
                  Atualizar Dados Financeiros
                </b-list-group-item>
                <b-list-group-item button
                   v-if="isUtilizaPlataformaPagamento" @click="openModalCartaoFisico">
                  <i class="fa fa-credit-card"></i>
                  Cartão Físico
                </b-list-group-item>
                <b-list-group-item
                  v-if="pedido.formadePagamento === 'Boleto' && isUtilizaPlataformaPagamento"
                  button
                  @click="$router.push({name: 'PedidoTransacoes', query:{id: pedido._id}})"
                >
                  <i class="fas fa-file-pdf"></i>
                  Imprimir Boleto
                </b-list-group-item>
                <b-list-group-item button @click="$bvModal.show('modalInfoPlano')">
                  <i class="fa fa-file-alt"></i>
                  Dados do Plano
                </b-list-group-item>
                <b-list-group-item v-if="!isUtilizaPlataformaPagamento" button @click="openModalStatusCartao">
                  <i class="fa fa-check-square"></i>
                  Status Cartão
                </b-list-group-item>
                <b-list-group-item
                  button
                  @click="$bvModal.show('modalCartao')"
                  v-if="exibeCartaoVirtual"
                >
                  <i class="icon-w fas fas fa-credit-card"></i>
                  Cartão Virtual
                </b-list-group-item>
                <b-list-group-item
                  button
                  @click="$bvModal.show('modalCartaoDependentes')"
                  v-if="exibeCartaoVirtualDependente"
                >
                  <i class="icon-w fas fas fa-credit-card"></i>
                  C.V. Dependente(s)
                </b-list-group-item>
                <b-list-group-item
                  button
                  v-if="getTextStatusPagamento(pedido.vads_trans_status) === 'Pago'"
                  @click="$bvModal.show('modalApolice')"
                >
                  <i class="fas fa-file-alt"></i>
                  Apólices
                </b-list-group-item>
                <b-list-group-item v-if="exibeEdicao"  button @click="$bvModal.show('modalEditClient')">
                  <i class="fas fa-edit"></i>
                  Editar
                </b-list-group-item>
                <b-list-group-item v-if="isAdministrador && isUtilizaPlataformaPagamento" button @click="$bvModal.show('modalTipoEnvio')">
                  <i class="far fa-envelope"></i>
                  Envio Fatura(via)
                </b-list-group-item>
                <b-list-group-item
                  v-if="isUtilizaPlataformaPagamento"
                  @click="transacoes"
                  button
                >
                  <i class="fas fa-receipt"></i>
                  Transações
                </b-list-group-item>
                <b-list-group-item
                  v-if="isUtilizaPlataformaPagamento"
                  @click="$router.push({name: 'PedidoTransacoesAvulsas', query:{id: pedido._id}})"
                  button
                >
                  <i class="fas fa-receipt"></i>
                  Transações Avulsas
                </b-list-group-item>
                <b-list-group-item button @click="openModalDocumento">
                  <i class="fas fa-file-contract"></i>
                  Documentos <h7 v-if="pedido.documentoExiste==false">(Pendente)</h7>
                </b-list-group-item>
                <b-list-group-item button @click="openModalSolicitacao">
                  <i class="fas fa-hands-helping"></i>
                  Solicitações
                </b-list-group-item>
                <b-list-group-item button @click="openTermoAdesao">
                  <i class="fas fa-file-contract"></i>
                  Termo Adesão
                </b-list-group-item>
                <b-list-group-item button @click="openModalAnotacao">
                  <i class="fas fa-book-open"></i>
                  Anotações
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modaCartaoFisico" title="Solicitar cartão físico" size="xl"
      hide-footer>
      <div class="container" v-if="pedido.cartaoFisico && pedido.cartaoFisico.statusPagamento === 'paid'">
        <div class="row">
          <div class="col">
             <b-alert show variant="warning">Cartão físico pago. Aguardando envio dos correios!</b-alert>
          </div>
        </div>
        <div class="row justify-content-end mt-4">
          <div class="col-3">
            <b-button @click="$bvModal.hide('modaCartaoFisico')">Fechar</b-button>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="pedido.cartaoFisico && pedido.cartaoFisico.statusPagamento === 'pending'">
        <div class="row">
          <div class="col">
             <b-alert show variant="warning">Solicitação de cartão físico realizado. Aguardando Pagamento!</b-alert>
          </div>
        </div>
        <div class="row justify-content-end mt-4">
          <div class="col-3 mr-5">
            <b-button target="_blank" :href="getChargeCartaoFisico(pedido.cartaoFisico.vindi.bill.charges).print_url">
              <i class="fa fa-file-pdf"></i> Imprimir Boleto
            </b-button>
          </div>
          <div class="col-3">
            <b-button @click="$bvModal.hide('modaCartaoFisico')">Fechar</b-button>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="!pedido.cartaoFisico">
        <div class="row">
          <div class="col">
            <small
              class="form-text text-muted"
            >Informe: Cada cartão físico tem um custo de emissão de R$ 12,00. E os cartões chegarão no endereço do títular</small>
            <br />
            <b-form-checkbox
              v-model="checkedCartaoFisico"
              name="check-button"
              switch
            >Títular ({{pedido.client.name}})</b-form-checkbox>
            <b-form-checkbox
              v-for="dep in pedido.client.dependentes"
              :key="dep.cpf"
              :value="dep"
              v-model="dependentesCartaoFisico"
              switch
            >{{dep.name}}</b-form-checkbox>
          </div>
        </div>
        <hr>
        <div class="row justify-content-between">
          <div class="col-4">
            <label>Total a Pagar</label>
          </div>
          <div class="col-4">
            {{valorTotalCartaoFisico | money}}
          </div>
        </div>
        <hr>

        <div class="row justify-content-end">
          <div class="col-3">
            <b-button @click="$bvModal.hide('modaCartaoFisico')">Cancelar</b-button>
          </div>
          <div class="col-3">
            <b-button :disabled="valorTotalCartaoFisico === 0" @click="solicitarCartaoFisico" variant="primary">Comprar</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="modalCartaoDependentes" title="Cartão Digital Dependente(s)" size="lg">
      <div class="container">
        <div class="row"
          v-for="(dependente, index) in pedido.client.dependentes" :key="index">
          <div class="col">
            <b-img
              thumbnail
              fluid
              :src="`${urlAWScartao}/${cartao.numeroCartao}-${toBase64(dependente.name)}-dep.png?t=${new Date().getTime()}`"
              alt="Image 1"
            ></b-img>
          </div>
          <div class="col" v-if="index === 0">
            <b-img thumbnail fluid :src="urlCartaoVerso" alt="Image 1"></b-img>
          </div>
          <div class="col-12">
            <b-button @click="enviarWhatsapDependente(dependente.name, `${urlAWScartao}/${cartao.numeroCartao}-${toBase64(dependente.name)}-dep.png`)">
              <i class="fab fa-whatsapp"></i>
              Enviar Via whatsapp
            </b-button>
          </div>
          <hr>
        </div>
      </div>
    </b-modal>
    <b-modal id="modalCartao" title="Cartão Digital" size="lg">
      <div class="container">
        <div class="row">
          <div class="col">
            <b-img
              thumbnail
              fluid
              :src="`${this.urlAWScartao}/${this.cartao.numeroCartao}.png?t=${new Date().getTime()}`"
              alt="Image 1"
            ></b-img>
          </div>
          <div class="col">
            <b-img thumbnail fluid :src="urlCartaoVerso" alt="Image 1"></b-img>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b-button @click="enviarWhatsapp()">
              <i class="fab fa-whatsapp"></i>
              Enviar Via whatsapp
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      footer-bg-variant="light"
      id="modalEditClient"
      size="lg"
      title="Editar dados Cliente"
      @ok="saveEditClient"
      ref="modalEditClient"
      ok-title="Salvar"
      cancel-title="Cancelar">
      <div>
        <div class="row">
          <div class="col">
            <b-tabs content-class="mt-3" fill>
              <b-tab v-if="exibeEdicao" title="Dados Básicos" :active="exibeEdicao">
                <div class="container">
                  <div class="form-row">
                    <div
                      class="form-group col-md-6"
                      :class="{'has-danger': errors.has('stepContent1.name')}"
                    >
                      <label for="username">Nome Completo</label>
                      <input
                        type="text"
                        name="name"
                        id="name"
                        v-validate="'required'"
                        v-model="pedido.client.name"
                        class="form-control"
                      />
                      <div
                        v-if="errors.has('stepContent1.name')"
                        class="help-block form-text text-muted form-control-feedback"
                      >{{errors.first('stepContent1.name')}}</div>
                    </div>
                    <div
                      class="form-group col-md-3"
                      :class="{'has-danger': errors.has('stepContent1.cpf')}"
                    >
                      <label for="username">CPF</label>
                      <input
                        type="tel"
                        name="cpf"
                        id="cpf"
                        v-mask="'###.###.###-##'"
                        v-validate="'required|cpf'"
                        v-model="pedido.client.cpf"
                        class="form-control"
                      />
                      <div
                        v-if="errors.has('stepContent1.cpf')"
                        class="help-block form-text text-muted form-control-feedback"
                      >{{errors.first('stepContent1.cpf')}}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-group col-md-4">
                        <div
                          class="form-group"
                          :class="{'has-danger': errors.has('stepContent1.dataNascimento')}"
                        >
                          <label for="date">Data de Nascimento</label>
                          <input
                            type="tel"
                            name="dataNascimento"
                            id="dataNascimento"
                            v-validate="'required|date_format:dd/MM/yyyy'"
                            v-model="pedido.client.dataNascimento"
                            v-mask="'##/##/####'"
                            class="form-control"
                            aria-describedby="helpId"
                          />
                          <div
                            v-if="errors.has('stepContent1.dataNascimento')"
                            class="help-block form-text text-muted form-control-feedback"
                          >{{errors.first('stepContent1.dataNascimento')}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <div
                        class="form-group"
                        :class="{'has-danger': errors.has('stepContent1.email')}"
                      >
                        <label for="email">E-mail</label>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          v-model="pedido.client.email"
                          v-validate="'required|email'"
                          class="form-control"
                          aria-describedby="helpId"
                        />
                        <div
                          v-if="errors.has('stepContent1.email')"
                          class="help-block form-text text-muted form-control-feedback"
                        >{{errors.first('stepContent1.email')}}</div>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <div
                        class="form-group"
                        :class="{'has-danger': errors.has('stepContent1.celular')}"
                      >
                        <label for="celular">Celular</label>
                        <input
                          type="tel"
                          name="celular"
                          id="celular"
                          v-model="pedido.client.telefoneCelular"
                          v-validate="'required'"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                          class="form-control"
                          aria-describedby="helpId"
                        />
                        <div
                          v-if="errors.has('stepContent1.celular')"
                          class="help-block form-text text-muted form-control-feedback"
                        >{{errors.first('stepContent1.celular')}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <div
                        class="form-group"
                        :class="{'has-danger': errors.has('stepContent1.fixo')}"
                      >
                        <label for="fixo">Tel. Fixo</label>
                        <input
                          type="tel"
                          name="fixo"
                          id="fixo"
                          v-model="pedido.client.telefoneFixo"
                          v-validate="'required'"
                          v-mask="['(##) ####-####']"
                          class="form-control"
                          aria-describedby="helpId"
                        />
                        <div
                          v-if="errors.has('stepContent1.fixo')"
                          class="help-block form-text text-muted form-control-feedback"
                        >{{errors.first('stepContent1.fixo')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab v-if="exibeEdicao" title="Endereço">
                <div>
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <div
                        class="form-group"
                        :class="{'has-danger': errors.has('stepContent2.cep')}"
                      >
                        <label for="celular">CEP</label>
                        <input
                          autofocus
                          type="tel"
                          name="cep"
                          id="cep"
                          @keyup="buscaCEP()"
                          v-model="pedido.client.cep"
                          v-validate="'required'"
                          v-mask="'#####-###'"
                          class="form-control"
                          aria-describedby="helpId"
                        />
                        <div
                          v-if="errors.has('stepContent2.cep')"
                          class="help-block form-text text-muted form-control-feedback"
                        >{{errors.first('stepContent2.cep')}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-9">
                      <div
                        class="form-group"
                        :class="{'has-danger': errors.has('stepContent2.endereco')}"
                      >
                        <label for="endereco">Endereço</label>
                        <input
                          type="text"
                          name="endereco"
                          id="endereco"
                          v-model="pedido.client.enderecoResidencial"
                          v-validate="'required'"
                          class="form-control"
                          aria-describedby="helpId"
                        />
                        <div
                          v-if="errors.has('stepContent2.endereco')"
                          class="help-block form-text text-muted form-control-feedback"
                        >{{errors.first('stepContent2.endereco')}}</div>
                      </div>
                    </div>
                    <div class="form-group col-md-3">
                      <div
                        class="form-group"
                        :class="{'has-danger': errors.has('stepContent2.nrEndereco')}"
                      >
                        <label for="celular">Número</label>
                        <input
                          type="tel"
                          name="nrEndereco"
                          id="nrEndereco"
                          v-model="pedido.client.enderecoNumero"
                          v-validate="'required'"
                          class="form-control"
                          aria-describedby="helpId"
                        />
                        <div
                          v-if="errors.has('stepContent2.nrEndereco')"
                          class="help-block form-text text-muted form-control-feedback"
                        >{{errors.first('stepContent2.nrEndereco')}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <div
                        class="form-group"
                        :class="{'has-danger': errors.has('stepContent2.complemento')}"
                      >
                        <label for="complemento">Complemento</label>
                        <input
                          type="text"
                          name="complemento"
                          id="complemento"
                          v-model="pedido.client.endereComplemento"
                          class="form-control"
                          aria-describedby="helpId"
                        />
                        <div
                          v-if="errors.has('stepContent2.complemento')"
                          class="help-block form-text text-muted form-control-feedback"
                        >{{errors.first('stepContent2.complemento')}}</div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <div
                        class="form-group"
                        :class="{'has-danger': errors.has('stepContent2.bairro')}"
                      >
                        <label for="bairro">Bairro</label>
                        <input
                          type="text"
                          name="bairro"
                          id="bairro"
                          v-model="pedido.client.bairro"
                          v-validate="'required'"
                          class="form-control"
                          aria-describedby="helpId"
                        />
                        <div
                          v-if="errors.has('stepContent2.bairro')"
                          class="help-block form-text text-muted form-control-feedback"
                        >{{errors.first('stepContent2.bairro')}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <div
                        class="form-group"
                        :class="{'has-danger': errors.has('stepContent2.cidade')}"
                      >
                        <label for="cidade">Cidade</label>
                        <input
                          type="text"
                          name="cidade"
                          id="cidade"
                          v-model="pedido.client.cidade"
                          v-validate="'required'"
                          class="form-control"
                          aria-describedby="helpId"
                        />
                        <div
                          v-if="errors.has('stepContent2.cidade')"
                          class="help-block form-text text-muted form-control-feedback"
                        >{{errors.first('stepContent2.cidade')}}</div>
                      </div>
                    </div>
                    <div class="form-group col-md-2">
                      <div
                        class="form-group"
                        :class="{'has-danger': errors.has('stepContent2.ufEndereco')}"
                      >
                        <label for="ufEndereco">UF</label>
                        <select
                          name="ufEndereco"
                          class="form-control"
                          id="ufEndereco"
                          v-validate="'required'"
                          v-model="pedido.client.uf"
                        >
                          <option :value="null">Selecione</option>
                          <option v-for="uf in ufs" :key="uf" :value="uf" v-text="uf" />
                        </select>
                        <div
                          v-if="errors.has('stepContent2.ufEndereco')"
                          class="help-block form-text text-muted form-control-feedback"
                        >{{errors.first('stepContent2.ufEndereco')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Dependentes" :active="!exibeEdicao">
                <div class="row">
                  <div class="col">
                    <button
                      @click="addDependente"
                      name
                      id
                      class="btn btn-success"
                      type="button"
                      :disabled="pedido.client.dependentes.length === sizeDependentes"
                    >
                      <i class="fa fa-plus"></i>
                      Adicionar
                      <b>{{pedido.client.dependentes.length + 1}} de {{sizeDependentes}}</b>
                    </button>
                  </div>
                </div>
                <div class="form-row mt-2">
                  <div class="col-5" v-for="(dependente, i) in pedido.client.dependentes" :key="i">
                    <b-button v-if="isAdministrador" variant="danger" @click="removeDepedente(i)">
                      <i class="fas fa-delete"></i> Remover
                    </b-button>
                    <h5>Dependente {{i + 1}}</h5>
                    <div
                      class="form-group"
                      :class="{'has-danger': errors.has(`stepContent3.dependenteNome${i}`)}"
                    >
                      <label for>Nome Completo</label>
                      <input
                        :name="`dependenteNome${i}`"
                        :id="`dependenteNome${i}`"
                        v-validate="'required'"
                        v-model="dependente.name"
                        type="text"
                        class="form-control"
                      />
                      <div
                        v-if="errors.has(`stepContent3.dependenteNome${i}`)"
                        class="help-block form-text text-muted form-control-feedback"
                      >{{errors.first(`stepContent3.dependenteNome${i}`)}}</div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div
                          class="form-group"
                          :class="{'has-danger': errors.has(`stepContent3.dependenteDtNascimento${i}`)}"
                        >
                          <label for>Data de Nascimento</label>
                          <input
                            :name="`dependenteDtNascimento${i}`"
                            :id="`dependenteDtNascimento${i}`"
                            v-validate="'required|date_format:dd/MM/yyyy'"
                            v-mask="'##/##/####'"
                            v-model="dependente.dataNascimento"
                            class="form-control"
                            type="tel"
                          />
                          <div
                            v-if="errors.has(`stepContent3.dependenteDtNascimento${i}`)"
                            class="help-block form-text text-muted form-control-feedback"
                          >{{errors.first(`stepContent3.dependenteDtNascimento${i}`)}}</div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div
                          class="form-group"
                          :class="{'has-danger': errors.has(`stepContent3.dependenteCPF${i}`)}"
                        >
                          <label for>CPF</label>
                          <input
                            :name="`dependenteCPF${i}`"
                            :id="`dependenteCPF${i}`"
                            v-validate="'required'"
                            v-mask="'###.###.###-##'"
                            v-model="dependente.cpf"
                            class="form-control"
                            type="tel"
                          />
                          <div
                            v-if="errors.has(`stepContent3.dependenteCPF${i}`)"
                            class="help-block form-text text-muted form-control-feedback"
                          >{{errors.first(`stepContent3.dependenteCPF${i}`)}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </b-modal>
     <b-modal
      footer-bg-variant="light"
      id="modalTipoEnvio"
      size="lg"
      title="Envio Fatura (Via)"
      @ok="saveEditEnvio"
      @cancel="voltarPedido"
      ref="modalTipoEnvio"
      ok-title="Salvar"
      cancel-title="Cancelar">
      <div>
        <div class="row">
           <label> Tipo Envios da Fatura:</label>
           <multiselect v-model="fatura.tipoEnvioFatura" :multiple="true"
            :taggable="true" :options="tipoEnvioFatura" :showLabels="false"
            :hide-selected="true"
            select-label=""
            label="name"
            value="name"
            track-by="name"
            :searchable="false"
            placeholder="Selecione o tipo de Envio">
            </multiselect>
        </div>
      </div>
    </b-modal>
    <b-modal id="modalDocumentos" title="Documentos" size="xl" hide-footer>
      <div class="container">
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label>Descrição</label>
              <select v-model="documento.descricao" class="form-control">
                <option :value="null">Selecione</option>
                <option value="Contrato">Contrato</option>
                <option value="Contrato">Termo de adesão</option>
                <option value="Identidade">Identidade</option>
                <option value="Outros">Outros</option>
              </select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>Arquivo</label>
              <div class="custom-file">
                <input
                  type="file"
                  class="custom-file-input"
                  @change="processFile($event)"
                  id="validatedCustomFile"
                  required
                />
                <label class="custom-file-label" for="validatedCustomFile">Informe o arquivo...</label>
              </div>
            </div>
          </div>
          <div class="col">
            <label for>&nbsp;</label>
            <b-button variant="light" @click="saveDocumento">
              <i class="fas fa-plus"></i>
            </b-button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <table class="table">
              <tr>
                <th>Descrição</th>
                <th>Arquivo</th>
                <th></th>
              </tr>
              <tbody>
                <tr v-for="docPedido in listDocumento" :key="docPedido._id">
                  <td>{{docPedido.descricao}}</td>
                  <td>
                    <a :href="urlArquivo(docPedido._id)" target="_blank" title="Download Arquivo">
                      <i class="fas fa-file-pdf"></i>
                    </a>
                  </td>
                  <td>
                    <b-button
                      variant="light"
                      title="Excluir"
                      @click="ExcluirDocumento(docPedido._id)"
                    >
                      <i class="fas fa-trash"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal ref="modalAddSolicitacao" id="modalAddSolicitacao" title="Nova Solicitação" size="xl" hide-footer>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Descrição</label>
              <textarea
                v-model="solicitacao.descricao"
                v-validate="'required'"
                name="solicitacaoDescricao"
                id="solicitacaoDescricao"
                cols="30"
                rows="4"
                class="form-control"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <b-button @click="saveSolicitacao">Salvar</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <div>
      <b-modal id="modalSolicitacao" title="Solicitações" size="lg" hide-footer>
        <div class="container">

          <div class="row">
            <div class="col">
              <p>Solicitações Realizadas</p>
            </div>
            <div class="col-2">
              <b-button @click="$bvModal.show('modalAddSolicitacao')">Nova</b-button>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col" style="width: 5%">Código</th>
                    <th scope="col" style="width: 10%">Data/Hora</th>
                    <th scope="col" style="width: 60%">Descrição</th>
                    <th scope="col" style="width: 25%">Status</th>
                  </tr>
                </thead>
                <tbody v-for="(sol, i) in listSolicitacao" :key="i">
                  <tr scope="row">
                    <td>{{sol.codigo}}</td>
                    <td>{{sol.createdAt | formatDate}}</td>
                    <td :title="sol.descricao">{{sol.descricao | truncate(100)}}</td>
                    <td>{{sol.status}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <b-modal id="modalInfoPlano" title="Informações do plano" size-xl hide-footer>
      <div class="container">
        <div id="printable">
          <div class="row">
            <div class="col-8">
              <label>Plano contratado</label>
              <h5>{{pedido.plano.name}}</h5>
            </div>
            <div class="col">
              <label>Preço</label>
              <h5>{{pedido.plano.price | money}}/mês</h5>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col">
              <label>Benefícios</label>
            </div>
          </div>
          <div class="row" v-for="beneficio in listBeneficio" :key="beneficio._id">
            <div class="col">
              <label>{{beneficio.titulo}}<h7>
                  A descrição do seguro, bem como detalhe, do benefício contratado
                  está disponível na apólice(Solicite a sua)
                </h7></label>
              <br />
              <ul>
                <li v-for="texto in beneficio.textoBeneficios" :key="texto">{{texto}}</li>
              </ul>
            </div>
          </div>
          <hr />
        </div>
        <div class="row text-center">
          <div class="col">
            <b-button variant="primary" @click="print">
              <i class="fa fa-print"></i>
              Imprimir
            </b-button>
          </div>
          <div class="col">
            <b-button variant="primary" @click="print">
              <i class="fa fa-email"></i>
              Enviar por email
            </b-button>
          </div>
          <div class="col">
            <b-button variant="success" @click="enviarDadosPlanoWhatsapp">
              <i class="fab fa-whatsapp"></i>
              Enviar Via WhatsApp
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="modalApolice" title="Documento das Apolices" hide-footer>
      <div class="container">
        <div class = "row text-center">
          <div class="col-6">
            <div class="form-group">
              <div class="custom-file">
                <b-button variant="light" title="Exibir Apolice" target="_blank" :href="`${this.urlAWScontrato}/${this.cartao.numeroCartao}.pdf`" >
                  <i class="fa fa-file-pdf"></i> Apolice
                </b-button>
              </div>
            </div>
          </div>

        </div>
        <div class="row text-center">
          <div class="col">
            <b-button variant="primary" @click="openDocument">
              <i class="fa fa-email"></i>
              Acessar apólice
            </b-button>
          </div>
          <div class="col">
            <b-button variant="success" @click="enviarApoliceWhatsapp">
              <i class="fab fa-whatsapp"></i>
              Enviar Via WhatsApp
            </b-button>
          </div>
        </div>
      </div>

    </b-modal>

    <b-modal ref="modalStatusCartao" id="modalStatusCartao" title="Alterar status do Cartão" size-xl hide-footer>
      <div class="container">
        <div class="row">
          <div class="col">
            <multiselect v-model="statusCartao" :options="statusPedidos"
              placeholder="Informe o status do cartao"
              :hide-selected="true">
            </multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b-button variant="primary" @click="atualizarStatusCartao" >Salvar</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="modalAddAnotacao" title="Nova Anotação" size="xl" hide-footer>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Descrição</label>
              <textarea
                  v-model="anotacao.descricao"
                  v-validate="'required'"
                  name="anotacaoDescricao"
                  id="anotacaoDescricao"
                  cols="30"
                  rows="4"
                  class="form-control"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <b-button @click="saveAnotacao">Salvar</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="modalAnotacao" title="Anotações" size="lg" hide-footer>
      <div class="container">
        <div class="row">
          <div class="col">
            <p>Anotações realizadas</p>
          </div>
          <div class="col-2">
            <b-button @click="$bvModal.show('modalAddAnotacao')">Nova</b-button>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <table class="table">
              <thead>
              <tr>
                <th scope="col" style="width: 10%">Data/Hora</th>
                <th scope="col" style="width: 80%">Descrição</th>
              </tr>
              </thead>
              <tbody v-for="(anotacao, i) in pedido.anotacoes" :key="i">
                <tr scope="row">
                  <td>{{ anotacao.dataCriacao | formatDate }}</td>
                  <td :title="anotacao.descricao">{{anotacao.descricao | truncate(100)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style scoped>
@media print {
  body * {
    visibility: hidden;
  }
  #printable,
  #printable * {
    visibility: visible;
  }
  #printable {
    position: fixed;
    left: 0;
    top: 0;
  }
}
</style>
<script>
import axios from "axios";
import moment from "moment";
import Multiselect from 'vue-multiselect';
import _ from 'lodash';

export default {
  async created() {
    await this.laodPedido();
  },
  components:{
    Multiselect
  },
  computed: {
    empresa() {
      return this.$store.getters.empresa;
    },
    isUtilizaPlataformaPagamento() {
      return this.$store.getters.empresa.utilizaPlataformaPagamento;
    },
    isUtilizaVindi() {
      return this.$store.getters.empresa.plataformaPagamento === 'vindi';
    },
    exibeCartaoVirtual() {
      if (!this.isUtilizaPlataformaPagamento) {
        return true;
      } else {
        return this.getTextStatusPagamento(this.pedido.vads_trans_status) === 'Pago';
      }
    },
    exibeCartaoVirtualDependente() {
      if (!this.isUtilizaPlataformaPagamento) {
        return this.pedido.client.dependentes.length > 0;
      } else {
        return this.getTextStatusPagamento(this.pedido.vads_trans_status) === 'Pago' && this.pedido.client.dependentes.length > 0;
      }
    },
    exibeEdicao() {
      if (!this.isUtilizaPlataformaPagamento) {
        return true;
      }
      return this.isAdministrador;
    },
    urlCartaoVerso() {
      return `${axios.defaults.baseURL}/api/juridicaImagemCartao/image?idJuridica=${this.empresa._id}&tipo=VERSO&t=${new Date().getTime()}`;
    },
    isAdministrador() {
      return this.$store.getters.isAdministrador;
    },
    qtdSolicitacao() {
      if (this.checkedCartaoFisico) {
        return this.dependentesCartaoFisico.length + 1;
      } else {
        return this.dependentesCartaoFisico.length
      }
    },
    valorTotalCartaoFisico() {
      return this.valorCartaoFisico * this.qtdSolicitacao;
    },
    user() {
      return this.$store.getters.user;
    },
    urlAWScartao() {
      return process.env.NODE_ENV === 'production' ? 'https://cartoes-admin2-drachei.s3-sa-east-1.amazonaws.com' : 'https://cartoes-drachei-dev.s3-sa-east-1.amazonaws.com'
    },
    urlAWScontrato() {
      return process.env.NODE_ENV === 'production' ? 'https://contratos-admin2-drachei.s3.sa-east-1.amazonaws.com' : 'https://contratos-drachei-dev.s3.sa-east-1.amazonaws.com'
    }
  },
  data() {
    return {
      anotacao: {},
      statusCartao: null,
      statusPedidos: [
              "Cancelado",
              "Inadimplente",
              "Suspenso",
              "Habilitado"
      ],
      formasDePagamento: [
        {
          value: "VISA",
          descricao: "CARTÃO DE CRÉDITO",
          image: require("@/assets/images/cartao_vazio.png"),
          tipoPagamento: "cartaoCredito"
        },
        {
          value: "ITAU_IB",
          descricao: "BOLETO",
          image: require("@/assets/img/cartoes/boleto_itau.png"),
          tipoPagamento: "Boleto"
        }],
      vads_payment_cards: {},
      valorCartaoFisico: 12,
      checkedCartaoFisico: true,
      dependentesCartaoFisico: [],
      listBeneficio: [],
      listSolicitacao: [],
      solicitacao: {},
      listDocumento: [],
      documento: {
        descricao: null,
        file: null
      },
      sizeDependentes: 5,
      pedido: {},
      cartao: {
        numeroCartao: ""
      },
      ufs: [
        "AC",
        "AL",
        "AM",
        "AP",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RO",
        "RS",
        "RR",
        "SC",
        "SE",
        "SP",
        "TO"
      ],
      tipoEnvioFatura:[{name:"E-mail"},{name:"Whatsapp"},{name:"Correio"}],
      fatura:{}
    }
  },
  methods: {
    async laodPedido() {
      let id = this.$route.query.id;

      const responsePedido = await axios.get(`/api/saude/${id}`);
      this.pedido = responsePedido.data;
      if (this.pedido.client && this.pedido.client.dataNascimento) {
        if (this.pedido.client.dataNascimento) {
          this.pedido.client.dataNascimento = this.formataData(this.pedido.client.dataNascimento);
        }
      }

      // eslint-disable-next-line
      console.log("Chamada Para ws Cartao do pedido", id);
      const responseCartao = await axios.get(`/api/cartao?pedido=${id}`);
      // eslint-disable-next-line
      console.log('Resposta servico', responseCartao.data);

      if (responseCartao.data.length > 0) {
        this.cartao = responseCartao.data[0];
      }

      if (this.pedido.plano) {
        this.sizeDependentes = this.pedido.plano.qtdDependentes ? this.pedido.plano.qtdDependentes : 5;
      }

      let strBeneficio = `${this.pedido.plano.beneficiosPlano}`;
      strBeneficio = strBeneficio.replace(/[" []]/gi, "");
      const responseBeneficiosPlano = await axios.get(
        `/api/beneficio?_id__in=${strBeneficio}`
      );
      const responseDocumento = await axios.get(`/api/documentoWriteLabel/documento?pedido=${id}`)
      this.pedido.documentoExiste = responseDocumento.data;
      this.listBeneficio = responseBeneficiosPlano.data;
    },
    async openModalCartaoFisico(){
      this.$store.dispatch('setLoading', true);

      this.laodPedido();

      this.$store.dispatch('setLoading', false);
      this.$bvModal.show('modaCartaoFisico');
    },
    async solicitarCartaoFisico() {

      try {
        this.$store.dispatch('setLoading', true);
        const responseComprarCartao = await axios.post(`/api/saude/comprarCartaoFisico?empresa=${this.empresa._id}`, {
          "idPedido": this.pedido._id,
          "paymentMethod": "bank_slip",
          "quantity": this.qtdSolicitacao,
          "dependentes": this.dependentesCartaoFisico.map(dep => dep.name),
          "client": {
            "idClienteVindi": this.pedido.client.idClienteVindi
          }
        });
        const data = responseComprarCartao.data;
        this.$bvModal.hide("modaCartaoFisico");

        window.open(data.bill.charges[0].print_url);

        this.$bvToast.toast(`Solicitação Geração de cartão físico realizada com sucesso!`, {
          title: `Solicitação criado com sucesso`,
          variant: 'success',
          solid: true
        });
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    },
    formataData(strData) {
      // eslint-disable-next-line
      console.log('DATA method FORMATADATA', strData);

      if (typeof strData === 'string') {
        if (strData.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
          const [day, month, year] = strData.split("/");
          try {
            let data = new Date(year, month -1, day);
            if (isNaN(data.valueOf())) {
              throw Error('Invalid date');
            }
            return moment.utc(data).format('DD/MM/YYYY');
          } catch (error) {
            return strData;
          }
        }
      }
      let data = new Date(strData);
      return moment.utc(data).format('DD/MM/YYYY');
    },
    openTermoAdesao() {
      window.open(`${axios.defaults.baseURL}/api/juridica/${this.empresa._id}/termo`);
    },
    async openModalSolicitacao() {
      this.$store.dispatch('setLoading', true);
      const response = await axios.get(`/api/solicitacoes?pedido=${this.pedido._id}`);
      this.listSolicitacao = response.data;
      this.$store.dispatch('setLoading', false);
      this.$bvModal.show("modalSolicitacao");
    },
    openModalAnotacao() {
      this.$bvModal.show("modalAnotacao");
    },
    async saveAnotacao() {
      try {
        this.$store.dispatch("setLoading", true);

        this.pedido = await axios.post(`/api/saude/${this.pedido._id}/anotacoes`, this.anotacao)
          .then(response => response.data)

        this.anotacao = {}
        this.$bvModal.hide("modalAddAnotacao");
      } catch (e) {
        // eslint-disable-next-line
        console.log(error);
      } finally {
        this.$store.dispatch("setLoading", false);
      }
    },
    async saveSolicitacao() {
      try {
        this.$store.dispatch("setLoading", true);
        await axios.post(`/api/solicitacoes`, {
          juridica: this.empresa,
          pedido: this.pedido,
          usuarioSolicitante: this.user,
          descricao: this.solicitacao.descricao,
        });

        this.$store.dispatch("setLoading", false);

        const responseSolicitacao = await axios.get(`/api/solicitacoes?pedido=${this.pedido._id}`);
        this.listSolicitacao = responseSolicitacao.data;

        this.$bvModal.hide("modalAddSolicitacao");
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
    },
    urlArquivo(id) {
      return `${axios.defaults.baseURL}/api/documentoWriteLabel/file?id=${id}`;
    },
    async ExcluirDocumento(id) {
      this.$store.dispatch("setLoading", true);
      await axios.delete(`/api/documentoWriteLabel/${id}`);
      this.loadDocumentos();
      this.$store.dispatch("setLoading", false);
    },
    async openModalDocumento() {
      this.$store.dispatch("setLoading", true);
      await this.loadDocumentos();
      this.$store.dispatch("setLoading", false);
      this.$bvModal.show("modalDocumentos");
    },
    async openModalApolice(){
        this.$store.dispatch("setLoading", true);
        this.$store.dispatch("setLoading", false);
        this.$bvModal.show("modalApolice");
    },
    async saveDocumento() {
      try {
        this.$store.dispatch("setLoading", true);
        const payload = new FormData();
        payload.append("file", this.documento.file);
        payload.append("idSaude", this.pedido._id);
        payload.append("descricao", this.documento.descricao);
        await axios.post("/api/documentoWriteLabel/upload/", payload);

        this.loadDocumentos();
        this.$store.dispatch("setLoading", false);
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
    },
    async loadDocumentos() {
      try {
        const response = await axios.get(
          "/api/documentoWriteLabel?select=descricao contentType&pedido=" +
            this.pedido._id
        );
      const responseDocumento = await axios.get(`/api/documentoWriteLabel/documento?pedido=${this.pedido._id}`)
      this.pedido.documentoExiste = responseDocumento.data;
        this.listDocumento = response.data;
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
    },
    processFile(event) {
      this.documento.file = event.target.files[0];
    },
    voltar() {
      window.history.back();
    },
    getTextStatusPagamento(statusVindi) {
      switch (statusVindi) {
        case "processing":
          return "Processando pagamento";
        case "failure":
          return "Falha ao processar pagamento";
        case "rejected":
          return "Pagamento rejeitado";
        case "waiting":
          return "Aguardando pagamento";
        case "success":
        case "paid":
          return "Pago";
        default:
          return statusVindi;
      }
    },
    getTextFormaPagamento(formaPagamento) {
      switch (formaPagamento) {
        case "cartaoCredito":
          return "Cartão Crédito";
        default:
          return formaPagamento;
      }
    },
    enviarWhatsapp() {
      let nrCelular = this.pedido.client.telefoneCelular;
      nrCelular = nrCelular.replace(/[() -]/gi, "");
      nrCelular = "55" + nrCelular;

      let msg = `${this.urlAWScartao}/${this.cartao.numeroCartao}.png`;

      let url = `https://api.whatsapp.com/send?phone=${nrCelular}&text=${msg}`;
      window.open(url);
    },
    async enviarWhatsapDependente(name, url) {
      let nrCelular = this.pedido.client.telefoneCelular;
      nrCelular = nrCelular.replace(/[() -]/gi, "");
      nrCelular = "55" + nrCelular;

      let msg = `Cartão do dependente: \r\n ${name} \r\n\r\n ${url}`;
      msg = window.encodeURIComponent(msg);

      let apiWhatsapp = `https://api.whatsapp.com/send?phone=${nrCelular}&text=${msg}`;
      window.open(apiWhatsapp);
    },
    async enviarDadosPlanoWhatsapp() {
      let nrCelular = this.pedido.client.telefoneCelular;
      nrCelular = nrCelular.replace(/[() -]/gi, "");
      nrCelular = "55" + nrCelular;

      let msgBeneficio = "";
      let msgAcheiDescontos = "";
      var outrosBeneficio = [];
      this.listBeneficio.forEach(ben => {
        if(ben.nome=="clubeAcheiDesconto"){
          msgBeneficio += ben.titulo + ": \r\n\r\n";
          msgBeneficio+="  "+ben.descricao+"\r\n\r\n";
          ben.textoBeneficios.forEach(texto => {
          msgBeneficio +="    -> "+ texto + "\r\n";
          msgBeneficio += "\r\n";
          });
          msgBeneficio+="\r\n"
        }else if( ben.nome=="drAchei"){
          msgAcheiDescontos += ben.titulo + ": \r\n\r\n";
          msgAcheiDescontos+="  "+ben.descricao+"\r\n\r\n";
          ben.textoBeneficios.forEach(texto => {
          msgAcheiDescontos +="    -> "+ texto + "\r\n";
          });
          msgAcheiDescontos += "\r\n";
        }
        else{
          outrosBeneficio.push(ben);
        }
      });
      msgBeneficio+= msgAcheiDescontos+"Outros Beneficio(s): \r\n \r\n";
      outrosBeneficio.forEach(ben =>{
        ben.textoBeneficios.forEach(texto => {
          msgBeneficio +="    -> "+ texto + "\r\n";
          });
      })


      let msg =
        `Plano contratado: ${this.pedido.plano.name}` +
        "\r\n\r\n" +
        "Preço: R$ " +
        this.pedido.plano.price
          .toFixed(2)
          .replace(".", ",")
          .replace(/(\d)(?=(\d{3})+,)/g, "$1.") +
        "\r\n\r\n" +
        "Benefícios" +
        "\r\n\r\n" +
        msgBeneficio;

      msg=msg.toUpperCase();

      msg = window.encodeURIComponent(msg);

      let url = `https://api.whatsapp.com/send?phone=${nrCelular}&text=${msg}`;
      window.open(url);
    },
    buscaCEP() {
      if (this.pedido.client.cep) {
        this.pedido.client.cep = this.pedido.client.cep.replace(/[-]/g, "");
        if (this.pedido.client.cep.length === 8) {
          axios
            .get(`https://viacep.com.br/ws/${this.pedido.client.cep}/json/`)
            .then(result => {
              let endereco = result.data;
              this.pedido.client.cidade = endereco.localidade;
              this.pedido.client.bairro = endereco.bairro;
              this.pedido.client.enderecoResidencial = endereco.logradouro;
              this.pedido.client.uf = endereco.uf;
              this.pedido.client.endereComplemento = endereco.complemento;
            });
        }
      }
    },
    addDependente() {
      if (this.pedido.client.dependentes.length < this.sizeDependentes) {
        this.pedido.client.dependentes.push({});
      }
    },
    removeDepedente(i) {
      this.pedido.client.dependentes.splice(i, 1);
    },
    async saveEditClient(bvModalEvt) {
      try {
        bvModalEvt.preventDefault();

        this.$store.dispatch('setLoading', true);

        const responsePedido = await axios.put(
          `/api/saude/client/${this.pedido._id}?idEmpresa=${this.empresa._id}`,
          this.pedido
        );

        this.pedido = responsePedido.data;
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      } finally {
        this.$nextTick(() => {
          this.$refs.modalEditClient.hide();
          this.$store.dispatch('setLoading', false);
        });
      }
    },
    async saveEditEnvio(bvModalEvt){
      const filtro = _.cloneDeep(this.fatura);
      try {
        bvModalEvt.preventDefault();
        if(filtro.tipoEnvioFatura){
          filtro.tipoEnvioFatura= filtro.tipoEnvioFatura.map(fp => fp.name);

          this.$store.dispatch('setLoading', true);
          const responsePedido = await axios.put(
            `/api/saude/${this.pedido._id}`,
          filtro
          );
          // eslint-disable-next-line
          console.log(responsePedido);
          this.laodPedido()
        }
      } catch (error) {
        this.$store.dispatch('setLoading', true);
        this.laodPedido()
        this.$store.dispatch('setLoading', false);
        // eslint-disable-next-line
        console.log(error);
      }finally {
        this.$nextTick(() => {
          this.$refs.modalTipoEnvio.hide();
          this.$store.dispatch('setLoading', false);
        });
      }
    },
    async voltarPedido(bvModalEvt){
       try {
        bvModalEvt.preventDefault();
        this.$store.dispatch('setLoading', true);

        const responsePedido = await axios.get(
          `/api/saude/${this.pedido._id}`
        );
        this.pedido = responsePedido.data
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }finally {
        this.$nextTick(() => {
          this.$refs.modalTipoEnvio.hide();
          this.$store.dispatch('setLoading', false);
        });
      }
    },
    openDocument() {
      window.open(
        `${this.urlAWScontrato}/${this.cartao.numeroCartao}.pdf`
      );
    },
    print() {
      var mywindow = window.open("", "PRINT");

      mywindow.document.write(
        "<html><head><title>Dados do Plano Contratado</title>"
      );
      mywindow.document.write("</head><body >");
      mywindow.document.write("<h1>Dados Do Plano Contratado</h1>");
      mywindow.document.write(document.getElementById("printable").innerHTML);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();
    },
    toBase64(name) {
      if (!name) return '';
      return window.btoa(name.normalize('NFD').replace(/[\u0300-\u036f]/g, ""));
    },
    getChargeCartaoFisico(charges) {
          if (!charges) {
            return {}
          }
          if (charges.length == 1) {
            return charges[0];
          }

          return charges.find(charge => charge.status === 'pending' || charges.status === 'paid')
        },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async atualizarDadosFinanceiros() {
      this.$store.dispatch('setLoading', true);
      const response = await axios.put(`/api/saude/${this.pedido._id}/financeiro`)
      const result = response.data;
      if (result.tempo) {
        await this.sleep(result.tempo * 1000);
        this.$store.dispatch('setLoading', false);
      }
    },
    openModalStatusCartao() {
      this.statusCartao = this.cartao.status;
      this.$bvModal.show('modalStatusCartao');
    },
    async atualizarStatusCartao() {
      try {
        this.$store.dispatch('setLoading', true);
        await axios.post(`/api/saude/${this.pedido._id}/atualizarStatusCartao`, {status: this.statusCartao});

        await this.laodPedido();

        this.$nextTick(() => {
          this.$refs['modalStatusCartao'].hide();
        });
      } catch (e) {
        alert(e);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    },
    transacoes() {
      if (this.empresa.utilizaPlataformaPagamento && this.empresa.plataformaPagamento === 'Pagar.me') {
        this.$router.push({name: 'TransacoesPagarme', query: {id: this.pedido._id}})
      } else {
        this.$router.push({name: 'PedidoTransacoes', query: {id: this.pedido._id}})
      }
    }
  },

};
</script>
